export const UPLOADER_PERMISSIONS_COLLECTION = 'collection';
export const UPLOADER_PERMISSIONS_PRIVATE = 'private';
export const UPLOADER_PERMISSIONS_DEFAULT = 'default';

export const TRANSCODE_HIGH_PRIORITY = 8;
export const TRANSCODE_MEDIUM_PRIORITY = 5;
export const TRANSCODE_LOW_PRIORITY = 4;

export const TRANSCODE_PRIORITY_OPTIONS = [
  { label: 'High', value: TRANSCODE_HIGH_PRIORITY },
  { label: 'Medium', value: TRANSCODE_MEDIUM_PRIORITY },
  { label: 'Low', value: TRANSCODE_LOW_PRIORITY },
];

export const UPLOADER_PERMISSIONS_COLLECTION_LABEL = 'Collection';
export const UPLOADER_PERMISSIONS_PRIVATE_LABEL = 'Only Me';
export const UPLOADER_PERMISSIONS_DEFAULT_LABEL = 'Default';

export const PERMISSIONS_OPTIONS = [
  {
    label: UPLOADER_PERMISSIONS_COLLECTION_LABEL,
    value: UPLOADER_PERMISSIONS_COLLECTION,
  },
  {
    label: UPLOADER_PERMISSIONS_PRIVATE_LABEL,
    value: UPLOADER_PERMISSIONS_PRIVATE,
  },
  {
    label: UPLOADER_PERMISSIONS_DEFAULT_LABEL,
    value: UPLOADER_PERMISSIONS_DEFAULT,
  },
];
